import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { scrollToSelector } from 'src/utils';
import { Logger } from '@shared/common/logger';
import type { ICommonBookData } from '@shared/jp/models';
import { BooksService } from 'src/app/shared/book-page-common/services/books.service';
import { Router } from '@angular/router';
import { faqDataCondensed } from 'src/app/data/faq/data';
import { ROUTE_PATH_FAQ } from '@studiobuki/web-core/lib/routing';
import { stepsData } from 'src/app/data/steps/data';
import type { IInputNameToValueMap, TInput } from '@shared/common/data/inputs';
import { IBookPreview } from '@shared/jp/data/products';
import { BOOK_ALIAS_TO_ID_MAP } from '@shared/jp/product';
import {
  reviewsData,
  reviewsDataTKBook1,
  reviewsDataTKBook2,
} from 'src/app/data/reviews/reviews';
import { DiscountService } from 'src/app/services/discount.service';

const log = new Logger('Preview -> SectionDetailsComponent');

// const giftHref = `${BASE_HREF}${ROUTE_PATH_GIFT_BUY}`;

@Component({
  selector: 'app-section-details',
  templateUrl: './section-details.component.html',
  styleUrls: ['./section-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionDetailsComponent {
  @Input() book!: IBookPreview;

  public readonly reviewsDataTKBook1 = reviewsDataTKBook1;

  public readonly reviewsDataTKBook2 = reviewsDataTKBook2;

  public readonly faqDataCondensed = faqDataCondensed;

  public readonly getErrorText = (invalidInput: TInput) =>
    // `TODO: Something went wrong with ${invalidInput.label}`;
    `[※主人公の名前を入力してください]`;

  public readonly stepsData = stepsData;

  public readonly reviewsData = reviewsData;

  constructor(
    public media: MediaObserver,
    public discountService: DiscountService,
    private _router: Router,
    private _booksService: BooksService,
  ) {}

  public async submitted(value: IInputNameToValueMap) {
    log.info('submitted', value);
    // const { alias, gift } = this;

    const common: Partial<ICommonBookData> = {};

    const newBookId = await this._booksService.createBookByAlias(
      this.book.alias,
      value,
      common,
    );

    log.info('created book', newBookId);

    await this._router.navigate(['book', newBookId], {});

    log.info('submit', /* alias, */ value);

    const bookAliasId = BOOK_ALIAS_TO_ID_MAP[this.book.alias];

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!bookAliasId) {
      log.error(`didn't manage to get bookAliasId by alias`, {
        alias: this.book.alias,
        bookAliasId,
      });
    }
  }

  onNoticeButtonClick() {
    scrollToSelector('app-section-banner-mermaid');
  }

  onFaqButtonClick() {
    return this._router.navigate([ROUTE_PATH_FAQ]);
  }
}
